import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

import { Subscription } from 'rxjs'
import { MachineState } from 'src/app/modules/touareg-control/models/states.models'
import { TouaregControlStateParamsService } from 'src/app/modules/touareg-control/services/touareg-control-state-params.service'
import { TouaregControlStateLayoutComponent } from '../../layout/touareg-control-state-layout.component';

@Component({
  selector: 'app-touareg-control-state-pick-candidate',
  templateUrl: './touareg-control-state-pick-candidate.component.html',
  styleUrls: ['./touareg-control-state-pick-candidate.component.scss'],
  imports: [TouaregControlStateLayoutComponent],
})
export class TouaregControlStatePickCandidateComponent {
  @Input()
  state!: MachineState

  public countdownMessage: string

  constructor(
    private _display: TouaregControlStateParamsService,
    private translate: TranslateService
  ) {
    this.countdownMessage = this.translate.instant('touareg.pickingAssets')
  }
}
